/**
 * Match hub: modal-style stack (parent `worldcup/_layout` hides WC header + tab bar on this branch).
 */

import { useMemo } from 'react';
import { Platform } from 'react-native';
import { Stack } from 'expo-router';
import { useTheme } from '../../../../src/theme/useTheme';
import { getWorldcupStyles } from '../../../../appStyles/_worldcup.styles';

export default function WorldCupMatchLayout() {
  const theme = useTheme();
  const styles = useMemo(() => getWorldcupStyles(theme, { safeAreaTop: 0 }), [theme]);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: styles.stackContentStyle,
        presentation: 'modal',
        animation: Platform.OS === 'web' ? 'fade' : 'slide_from_bottom',
        gestureEnabled: true,
      }}
    />
  );
}
